export const ShareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 9C5.33333 9 4 10.3333 4 12C4 13.6667 5.33333 15 7 15C8.66667 15 10 13.6667 10 12C10 10.3333 8.66667 9 7 9ZM18 3C16.3333 3 15 4.33333 15 6C15 7.66667 16.3333 9 18 9C19.6667 9 21 7.66667 21 6C21 4.33333 19.6667 3 18 3ZM18 15C16.3333 15 15 16.3333 15 18C15 19.6667 16.3333 21 18 21C19.6667 21 21 19.6667 21 18C21 16.3333 19.6667 15 18 15ZM16.7193 16.1579L9.22807 12.0877L8.2807 13.8421L15.7719 17.9123L16.7193 16.1579ZM9.22807 11.9123L16.7193 7.84211L15.7719 6.08772L8.2807 10.1579L9.22807 11.9123Z"
      fill="#E90C1B"
    />
  </svg>
)
